export default "__VITE_ASSET__DXgJYGZh__"